export function getFullPostType(platform: string, postType: string, hasRecommendedGroup: boolean): string {
	return `${platform}${hasRecommendedGroup ? '_group' : ''}_${postType}`;
}

export function getFullPostTypeForTracking(platform: string, postType: string, hasRecommendedGroup: boolean): string {
	const fullPostType = getFullPostType(platform, postType, hasRecommendedGroup);

	if ((platform === 'reddit' || platform === 'facebook') && hasRecommendedGroup) {
		return `${platform}_group`;
	}
	return fullPostType;
}
